module.exports = __webpack_public_path__ + "static/media/eqcryo.cec03c39.png";